import { createRouter, createWebHistory, RouterView } from "vue-router";
import Body from "../components/body";
import Default from "../pages/dashboard/defaultPage.vue";
import finance from "@/pages/finance/finance.vue";
import generation from "@/pages/generation/generation";
import distribution from "@/pages/distribution/distribution";
import StorageConfig from "@/services/config/StorageConfig";
import { decrypt, checkIsGuest } from "@/utils/helper";
import { menuItems } from "@/data/menu";

const getApps = () => {
  try {
    const dataUser = StorageConfig.getData();
    if (dataUser) {
      return JSON.parse(decrypt(dataUser));
    }
  } catch (e) {
    console.error(e);
  }
  return null;
};

const apps = getApps();

const routes = [
  {
    path: "/post-login",
    name: "Login",
    component: () => import("@/pages/login/Login.vue"),
  },
  {
    path: "/",
    component: Body,

    children: [
      {
        path: "management-contract",
        name: "PLN Management Contract",
        component: Default,
        meta: {
          reqAuth: true,
        },
      },
      {
        path: "profile",
        name: "Profile",
        component: () => import("@/pages/profile/Profile.vue"),
        meta: {
          reqAuth: true,
        },
      },
      {
        path: "",
        redirect:
          apps?.menus?.[0]?.path && apps?.menus?.[0]?.path !== "/"
            ? apps.menus[0].path
            : "/finance",
        name: "Finance",
        component: RouterView,
        children: [
          {
            path: "/finance",
            component: () => import("@/pages/finance/finance.vue"),
            meta: {
              reqAuth: true,
            },
          },
          {
            path: "/detail-cash",
            name: "Cash Management",
            component: () => import("@/pages/finance/component/DetailCash.vue"),
            meta: {
              reqAuth: true,
            },
          },
          {
            path: "/detail-assets",
            name: "Asset Management",
            component: () =>
              import("@/pages/finance/component/DetailAssets.vue"),
            meta: {
              reqAuth: true,
            },
          },
          {
            path: "/detail-profit",
            name: "Profit & Loss",
            component: () =>
              import("@/pages/finance/component/DetailProfit.vue"),
            meta: {
              reqAuth: true,
            },
          },
        ],
      },
      {
        path: "data-moonshot",
        name: "moonshot",
        component: () => import("@/pages/moonshot/moonshot.vue"),
        meta: {
          reqAuth: true,
        },
      },
      {
        path: "legal-human-capital",
        name: "Legal & Human Capital",
        component: () => import("@/pages/legal/Index.vue"),
        meta: {
          reqAuth: true,
        },
      },
      {
        path: "summary",
        name: "Cross-Directorate Summary",
        component: () => import("@/pages/summary/Summary.vue"),
        meta: {
          reqAuth: true,
        },
      },
      {
        path: "generation",
        name: "Generation",
        component: generation,
        meta: {
          reqAuth: true,
        },
      },
      {
        path: "distribution",
        name: "Distribution",
        component: distribution,
        meta: {
          reqAuth: true,
        },
      },
      {
        path: "esg",
        name: "ESG",
        component: () => import("@/pages/esg/Esg.vue"),
        meta: {
          reqAuth: true,
        },
      },
      {
        path: "retail-commerce",
        name: "Retail & Commerce",
        component: () => import("@/pages/retail-new/RetailCommerceNew.vue"),
        meta: {
          reqAuth: true,
        },
      },
      {
        path: "risk",
        name: "Risk",
        component: () => import("@/pages/risk/Risk.vue"),
        meta: {
          reqAuth: true,
        },
      },
      {
        path: "transmission",
        name: "Transmission",
        component: () => import("@/pages/transmission/Transmission.vue"),
        meta: {
          reqAuth: true,
        },
      },
      {
        path: "strategy",
        name: "Strategy",
        component: () => import("@/pages/strategy/Strategy.vue"),
        meta: {
          reqAuth: true,
        },
      },
      {
        path: "primary",
        name: "Primary Energy",
        component: () => import("@/pages/primary/PrimaryEnergy.vue"),
        meta: {
          reqAuth: true,
        },
      },
      {
        path: "project-management",
        name: "project Management",
        component: () =>
          import("@/pages/project-management/ProjectManagement.vue"),
        meta: {
          reqAuth: true,
        },
      },
      {
        path: "cross-directorate-summary",
        name: "cross directorate summary",
        component: () =>
          import("@/pages/cross-directorate/CrossDirectorate.vue"),
        meta: {
          reqAuth: true,
        },
      },
    ],
  },
  {
    path: "/:pathMatch(.*)*",
    name: "NotFound",
    component: () => import("@/pages/error/Error404.vue"),
  },
];
const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});
router.beforeEach((to, from, next) => {
  const reqLogout = to.matched.some((record) => record.meta.reqLogout); // false
  const reqAuth = to.matched.some((record) => record.meta.reqAuth); // false
  const reqToken = !!StorageConfig.getData(); // false

  let isGuest = checkIsGuest();

  if (reqToken && isGuest && to.path !== "/profile" && to.path !== "/post-login") {
    next("/profile");
    return;
  }

  if (reqAuth === true) {
    if (reqToken === false) {
      next("/post-login");
    } else {
      const currentApps = getApps();
      if (currentApps && currentApps.menus) {
        const matchedMenu = menuItems.data.find((m) => m.path === to.path);
        
        if (matchedMenu && matchedMenu.id) {
          const isAllowed = currentApps.menus.some((apiMenu) => apiMenu.id === matchedMenu.id);
          
          if (!isAllowed) {
            next({ name: "NotFound", params: { pathMatch: to.path.substring(1).split('/') } });
            return;
          }
        }
      }
      next();
    }
  } else {
    // if reqAuth = false
    // eslint-disable-next-line no-lonely-if
    if (reqToken === true && reqLogout === true) {
      next("/");
    } else {
      next();
    }
  }
});
export default router;
